module.exports = __webpack_public_path__ + "img/slide-1.9759a594.webp";